<template>
    <div>
        {{ msg }}
    </div>
</template>

<script>
export default {
    name: "settings",
    data() {
        return {
            msg: 'General Settings Here',
        }
    },
}
</script>

<style scoped>

</style>
